import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-02/lesson-08/task-03";

const task: Slide = {
  title: "Listen to the sounds and group them according to their most prominent psychoacoustic parameter:",
  description: "Drag and drop sound samples.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
